export default {
  choise: 'Select',
  enter: 'Enter content here',
  show: 'Preview',
  edit: 'Comments',
  submit: 'Submit',
  close: 'Close',
  groupTemp1:	'Above (Assist: no need to transcribe)',
  groupTemp2:	'Below (Assist: no need to transcribe)'
}



// WEBPACK FOOTER //
// ./src/lang/en/group.js